/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { decode } from 'jsonwebtoken';
import { Route, Redirect, useLocation } from 'react-router-dom';

function exigeTrocaSenha(autenticacao) {
  if (autenticacao.senhaExpirada) {
    return true;
  }

  if (!autenticacao.token) {
    return false;
  }

  const decoded = decode(autenticacao.token);
  return Boolean(decoded && decoded.senha_expirada);
}

export default function RouteWrapper({
  component: Component,
  isPrivate,
  path,
  ...rest
}) {
  const autenticacao = useSelector((state) => state.autenticacao);
  const location = useLocation();
  const { logado } = autenticacao;
  const trocaObrigatoria = exigeTrocaSenha(autenticacao);
  const naTelaTroca = location.pathname === '/trocar-senha';

  const rotaRecuperacao =
    path === '/recuperar-senha/:tipo' ||
    path === '/recuperar-senha/administrador' ||
    path === '/esqueci-senha';

  if (!rotaRecuperacao) {
    if (!logado && (isPrivate || naTelaTroca)) {
      return <Redirect to="/" />;
    }

    if (logado && trocaObrigatoria && !naTelaTroca) {
      return <Redirect to="/trocar-senha" />;
    }

    if (logado && !trocaObrigatoria && !isPrivate) {
      return <Redirect to="/home" />;
    }
  }

  return (
    <Route path={path} {...rest} render={(props) => <Component {...props} />} />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  path: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
};
